export const SAVE_VISA_REQUESTED = 'SAVE_VISA_REQUESTED'
export const SAVE_VISA_SUCCEEDED = 'SAVE_VISA_SUCCEEDED'
export const SAVE_VISA_FAILED = 'SAVE_VISA_FAILED'

export const GET_FILE_URL_REQUESTED = 'GET_FILE_URL_REQUESTED'
export const GET_FILE_URL_SUCCEEDED = 'GET_FILE_URL_SUCCEEDED'
export const GET_FILE_URL_FAILED = 'GET_FILE_URL_FAILED'